export class ProductSortToggleHandler {
    public handleSortChange(input: HTMLInputElement): void {
        const sort = input.checked ? input.value : "latest_review_at";
        const params = new URLSearchParams(globalThis.location.search);
        params.set("sort", sort);
        params.delete("page");
        globalThis.location.href = `${globalThis.location.pathname}?${params.toString()}`;
    }
}
